/* global ReactSpringserveComponent */

angular.module("vastdesk").component("clearlineQaExportModal", {
  template: require("../templates/clearlineQaExportModal.html"),
  controllerAs: "$clearlineQaExportModalCtrl",
  controller: [
    "$scope",
    function ($scope) {
      const self = this;

      this.rootId = `component-root-angular-ModalClearlineQaExport-${Math.floor(
        Math.random() * 2 ** 52
      )}`;

      this.open = false;
      this.unregisterWatcher = null;

      this.handleClearlineQaExportModalOpenChange = (open) => {
        self.open = open;
        $scope.$applyAsync();
      };

      this.renderReactComponent = () => {
        return window.reactComponentScriptLoaded.promise.then(() => {
          ReactSpringserveComponent.renderComponent({
            componentName: "ModalClearlineQaExport",
            rootId: self.rootId,
            componentProps: {
              open: self.open,
              setOpen: self.handleClearlineQaExportModalOpenChange,
            },
          });
        });
      };

      this.$onInit = () => {
        self.renderReactComponent().then(() => {
          self.unregisterWatcher = $scope.$watch(
            "$clearlineQaExportModalCtrl.open",
            () => {
              self.renderReactComponent();
            }
          );
        });
      };

      this.$onDestroy = () => {
        if (self.unregisterWatcher) {
          self.unregisterWatcher();
        }
      };
    },
  ],
});
